import axios from 'axios'
import { API_URL } from './index'
import { REQUEST_REPORTS, RECEIVE_REPORTS } from '../constants/ActionTypes'

//= ===============================
// Fetch Multiple Reports Action
//= ===============================

const requestReports = (category) => {
	return {
		type: REQUEST_REPORTS,
		category
	}
}

const receiveReports = (category, response) => {
	return {
		type: RECEIVE_REPORTS,
		category,
		payload: response.data,
		receivedAt: Date.now()
	}
}

const fetchReports = (category, pageCount) => {
	return dispatch => {
		dispatch(requestReports(category))
		let url = `${API_URL}/story/all?published=true&page=` + pageCount + `&limit=5&type=` + category + `&meta=published`
		axios.get(url)
		.then((response) => {
			dispatch(receiveReports(category, response))
		})
		.catch((error) => {
			console.log(error)	
		})
	}
}

const shouldFetchReports = (state, category) => {
	const reports = state.reportsByCategory[category]
	if (!reports) {
		return true
	} else if (reports.isFetching) {
		return false
	}
	return true
}

export const loadReports = (category, nextPage) => (dispatch, getState) => {
	const {
		pageCount = 0
	} = getState().reportsByCategory[category] || {}
	if (pageCount > 0 && !nextPage) {
		return null
	}
	if (shouldFetchReports(getState(), category)) {
		return dispatch(fetchReports(category, pageCount))
	}
}


// WEBPACK FOOTER //
// ./src/actions/reports.js